/// <amd-module name="Test/TestPlansHubRefresh/TestPlansHubRefreshDialogs/DeleteSuiteCfmDialog/DeleteTestSuiteConfirmationDialog" />
import * as React from "react";
import { SuitesActions } from "Test/TestPlansHubRefresh/TestHub/Redux/Suites/SuitesActions";
import * as Resources from "Test/TestPlansHubRefresh/TestPlansHubRefreshDialogs/DeleteSuiteCfmDialog/Resources";
import * as Contracts from "TestPlanCommon/Contracts/TestPlan";
import { ObservableValue } from "VSS/Core/Observable";
import * as Utils_String from "VSS/Core/Util/String";
import { Components, VssComponent } from "VSS/Platform/Layout";
import { Button } from "VSSUI/Button";
import { CustomDialog } from "VSSUI/Dialog";
import { CustomHeader, HeaderTitle, TitleSize } from "VSSUI/Header";
import { Observer } from "VSSUI/Observer";
import { PanelContent, PanelFooter } from "VSSUI/Panel";
import { TextField } from "VSSUI/TextField";

export interface IDeleteTestSuiteConfirmationDialogProps {
    planId: number;
    suiteId: number;
    rootSuiteId: number;
    suiteName: string;
    suiteType: Contracts.TestSuiteType;
    selection: any;
    dispatch: any;
    childSuitesCount: number;
    onDismiss: () => void;
}

export interface IDeleteTestSuiteConfirmationDialogState {
    confirmDisabled?: boolean;
}

export class DeleteTestSuiteConfirmationDialog extends VssComponent<
    IDeleteTestSuiteConfirmationDialogProps,
    IDeleteTestSuiteConfirmationDialogState
> {
    private enteredSuiteId = new ObservableValue<string>("");
    private suiteNameAndId = Utils_String.format(Resources.SuiteNameAndId, this.props.suiteName, "" + this.props.suiteId);
    private suiteDeleteDetails = Utils_String.format(Resources.SuiteDeleteWarningMessage, "" + this.props.childSuitesCount);

    public onChange(newValue: string) {
        this.enteredSuiteId.value = newValue;

        if (Number(newValue) == this.props.suiteId) {
            this.setState({ confirmDisabled: false });
        } else {
            this.setState({ confirmDisabled: true });
        }
    }

    constructor(props: IDeleteTestSuiteConfirmationDialogProps) {
        super(props);
        this.state = { confirmDisabled: true };

        this.onChange = this.onChange.bind(this);
    }

    public render(): JSX.Element {
        return (
            <CustomDialog
                calloutContentClassName="delete-dialog-callout-element"
                className="testplanshubrefresh-delete-test-suite-confirmation-dialog"
                onDismiss={this.props.onDismiss}
                modal={true}
                defaultActiveElement=".suite-id-confirmation-input"
                ariaLabel={Resources.PermanentlyDeleteTestArtifactsDialogAriaLabel}
            >
                <div className="v-scroll-auto">
                    <CustomHeader className="hubrefresh-bolt-header-with-commandbar">
                        <HeaderTitle titleSize={TitleSize.Large}>{Resources.PermanenetlyDeleteTestArtifiacts}</HeaderTitle>
                    </CustomHeader>
                    <Observer>
                        {(props: {}) => {
                            return (
                                <div className="delete-test-suite-confirmation-dialog-description-wrapper">
                                    <PanelContent className="body-m">
                                        <div className="delete-test-suite-confirmation-dialog-confirmation-text">
                                            {Resources.SuiteDeleteConfirmationText}
                                            <strong>{this.suiteNameAndId}</strong>
                                            {this.suiteDeleteDetails}
                                        </div>
                                    </PanelContent>
                                    <div className="delete-test-suite-confirmation-dialog-top-padding">
                                        <PanelContent className="body-m font-weight-semibold delete-test-suite-confirmation-dialog-bottom-padding test-suite-delete-confirmation-dialog-top-padding">
                                            {Resources.SuiteIdConfirmationText}
                                        </PanelContent>
                                        <PanelContent className="body-m delete-test-suite-confirmation-dialog-bottom-padding">
                                            <div className="body-m flex-grow delete-test-suite-confirmation-dialog-right-padding">
                                                <TextField
                                                    rows={1}
                                                    inputClassName="suite-id-confirmation-input"
                                                    placeholder={Resources.SuiteIdConfirmationText}
                                                    value={this.enteredSuiteId}
                                                    onChange={(e, newValue) => {
                                                        this.onChange(newValue);
                                                    }}
                                                    onKeyDown={(e) => {
                                                        if (e.key === "Enter" && !this.state.confirmDisabled) {
                                                            this.deleteTestSuite();
                                                            this.props.onDismiss();
                                                        }
                                                    }}
                                                />
                                            </div>
                                        </PanelContent>
                                    </div>
                                </div>
                            );
                        }}
                    </Observer>
                    <PanelFooter className="body-m delete-dialog-footer">
                        <Button
                            id="suite-delete-confirm-button"
                            primary={true}
                            className="delete-test-suite-confirmation-dialog-footer-button"
                            text={Resources.Confirm}
                            disabled={this.state.confirmDisabled}
                            onClick={() => {
                                this.deleteTestSuite();
                                this.props.onDismiss();
                            }}
                        />
                        <Button
                            primary={false}
                            className="delete-test-suite-confirmation-dialog-footer-button"
                            text={Resources.Cancel}
                            onClick={() => {
                                this.props.onDismiss();
                            }}
                        />
                    </PanelFooter>
                </div>
            </CustomDialog>
        );
    }

    private deleteTestSuite(): void {
        this.props.dispatch(
            SuitesActions.deleteTestSuite(
                this.props.planId,
                this.props.suiteId,
                this.props.rootSuiteId,
                this.props.suiteName,
                this.props.suiteType,
                this.props.selection
            )
        );
    }
}

Components.add("DeleteTestSuiteConfirmationDialog", DeleteTestSuiteConfirmationDialog);
